import style from './checkbox.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import { ISpecialitiesItem } from '@components/careers/vacancies/vacancies.interfaces';
import React, { useEffect, useState } from 'react';
import VacancyForm from '@components/shared/forms/vacancy-form/vacancy-form';

interface ICheckboxProps {
  title: string;
  addSpecialty: () => void;
  deleteSpecialty: () => void;
  isFormSubmitted: boolean;
}

const Checkbox = ({ title, addSpecialty, deleteSpecialty, isFormSubmitted }: ICheckboxProps) => {
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    if (isChecked) {
      addSpecialty();
    } else {
      deleteSpecialty();
    }
  }, [isChecked]);

  useEffect(() => {
    if (isFormSubmitted && isChecked) {
      setIsChecked(false);
    }
  }, [isFormSubmitted]);

  return (
    <label className={`${style.container}`}>
      <input
        type="checkbox"
        onChange={() => {
          setIsChecked(!isChecked);
        }}
      />
      <svg
        className={`${style.checkbox} ${isChecked ? `${style.checkbox__active}` : ''}`}
        aria-hidden="true"
        viewBox="0 0 15 11"
        fill="none"
      >
        <path d="M1 4.5L5 9L14 1" strokeWidth="2" stroke={isChecked ? '#024D40' : 'none'} />
      </svg>
      <div className={`${style.title}`}>{title}</div>
    </label>
  );
};

export default Checkbox;
